import { type InboxPage, unwrap } from '@iris/shared';
import { useAuth } from '@iris/ui/auth/auth-provider';
import { useInfiniteQuery } from '@tanstack/react-query';

/** The inbox, page by page (also read by the tab badge from the first page's `unread`). */
export function useInbox() {
  const { api } = useAuth();
  return useInfiniteQuery({
    queryKey: ['inbox'],
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page: InboxPage) => page.nextCursor ?? undefined,
    queryFn: async ({ pageParam }): Promise<InboxPage> =>
      unwrap(await api.GET('/api/v1/inbox', { params: { query: pageParam ? { cursor: pageParam } : {} } })),
    refetchInterval: 60_000,
  });
}
